var $77110a8f3000e559$exports = {};
$77110a8f3000e559$exports = {
  "help": `\u{5E2}\u{5D6}\u{5E8}\u{5D4}`,
  "info": `\u{5DE}\u{5D9}\u{5D3}\u{5E2}`
};
export { $77110a8f3000e559$exports as default };